import { Dropdown as FlowbiteDropdown } from "flowbite-react";
export default FlowbiteDropdown;
